/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
export default {
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetViewGrnInformationByGroupIdFactoryIdDate,
    GetRouteByFactoryID,
    GetVCCFactoriesByGroupID,
    GetAllProductVarietyByProductID,
    GetProductCategoties,
    GetProductTypes,
    GetProductDetails,
    GetProductsByFactoryIDProductcatogeryID,
    SupplierPayementVerificationReportDetails
};

async function GetProductsByFactoryIDProductcatogeryID(operationEntityID, productcatogeryID) {
    const response = await CommonGet('/api/Product/GetProductsByFactoryIDProductcatogeryID', 'factoryID=' + operationEntityID + '&productcatogeryID=' + productcatogeryID);
    return response.data;
}

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductTypes() {
    const response = await CommonGet('/api/ProductType/GetAllProductTypes', null);
    return response.data;
}

async function GetProductDetails(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetAllProducts', 'productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetVCCFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetVCCFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetRouteByFactoryID(operationEntityID) {
    const response = await CommonGet('/api/Group/GetRouteByFactoryID', 'factoryID=' + parseInt(operationEntityID));
    return response.data;
}

async function GetViewGrnInformationByGroupIdFactoryIdDate(groupID, operationEntityID, date) {
    const response = await CommonGet('/api/GoodRecieveNote/GetGoodReciveNoteDetails', 'groupID=' + parseInt(groupID)
        + '&factoryID=' + parseInt(operationEntityID) + '&date=' + date);
    return response.data;
}

async function GetAllProductVarietyByProductID(productID) {
    const response = await CommonGet('/api/Product/GetAllProductVarietyByProductID', 'productID=' + productID);
    return response.data;
}

async function SupplierPayementVerificationReportDetails(model) {
    const response = await CommonPost('/api/SupplierPaymentVerificationReport/SupplierPaymentVerificationReportDetails', null, model);
    return response.data;
}




